// extracted by mini-css-extract-plugin
export default {"root":"ContentSection_root__hcR8K","width-wrapper":"ContentSection_width-wrapper__QsKTq","widthWrapper":"ContentSection_width-wrapper__QsKTq"};